import { render, staticRenderFns } from "./AddOneToCart.vue?vue&type=template&id=264156d6&scoped=true"
import script from "./AddOneToCart.vue?vue&type=script&lang=ts"
export * from "./AddOneToCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264156d6",
  null
  
)

export default component.exports